@if (text) {
  <button (click)="openUploadDialog()" [disabled]="disabled" color="primary" mat-raised-button>
    <mat-icon style="margin-right: 5px;">cloud_upload</mat-icon>
    <mat-label>{{ text }}</mat-label>
  </button>
} @else {
  <button (click)="openUploadDialog()" [disabled]="disabled" color="primary" mat-icon-button>
    <mat-icon>cloud_upload</mat-icon>
  </button>
}
